import { render, staticRenderFns } from "./PreOrderLabel.vue?vue&type=template&id=b5ddf37c&"
import script from "./PreOrderLabel.vue?vue&type=script&lang=js&"
export * from "./PreOrderLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports